// Module
var code = `<div class="HOA-flextable-component HOA-flextable-component__form">
    <div [ngClass]="{ 'is-invalid': firstNameError }"
         class="Field
                        HOA-flextable-component__cell--50-ifSizeIsLargerThanPhone
                        HOA-flextable-component__cell--100-field HOA-flextable-component__cell-field">
        <label tid="firstNameLabel" id="firstNameLabel" for="firstName" class="Field-label">
            First Name
            <span class="asterisk-required">&nbsp;&#42;</span>
        </label>
        <input type="text"
               class="Input"
               id="firstName"
               tid="firstName"
               name="firstName"
               maxlength="25"
               [(ngModel)]="personalInfoData.homeowner.firstName"
               (change)="firstName()"
               required
               aria-invalid="firstNameError"
               attr.aria-describedby="{{firstNameError && 'firstName-error' || undefined }}" >
        <span class="Field-error" tid="firstName-error" id="firstName-error">Please enter your first name.</span>
    </div>
    <div [ngClass]="{ 'is-invalid': lastNameError }"
         class="Field
                        HOA-flextable-component__cell--50-ifSizeIsLargerThanPhone
                        HOA-flextable-component__cell--100-field HOA-flextable-component__cell-field">
        <label tid="lastNameLabel" id="lastNameLabel" for="lastName" class="Field-label">
            Last Name
            <span class="asterisk-required">&nbsp;&#42;</span>
        </label>
        <input type="text"
               class="Input"
               id="lastName"
               tid="lastName"
               name="lastName"
               maxlength="35"
               [(ngModel)]="personalInfoData.homeowner.lastName"
               (change)="lastName()"
               required
               aria-invalid="lastNameError"
               attr.aria-describedby="{{lastNameError && 'lastName-error' || undefined }}">
        <span class="Field-error" tid="lastName-error" id="lastName-error">Please enter your last name.</span>
    </div>
    <app-email  class="Field HOA-flextable-component__cell--100-field HOA-flextable-component__cell-field"
                [ngClass]="{ 'is-invalid': personalInfoData.emailAddressError }"
                [personalInfoData]="personalInfoData"
                (invalidCheck)="onInvalidCheck(\$event)">
    </app-email>
    <div *ngIf="personalInfoData.emailAddressExists &&
                        personalInfoData.isHoaHomeowner &&
                        personalInfoData.registeredUserEnabled"
         class="u-mB7 u-mH4 u-bgBlueLightest u-rounded u-pA4 HOA-flextable-component__cell&--100-field">
        <div tid="registeredUserLabel" id="registeredUserLabel" class="HOA-guest-payment-header-light u-pB3">
            Registered User
        </div>
        <div class="HOA-flex-component HOA-guest-payment-sm-col-lg-row HOA-guest-payment-register-flex">
            <div class="HOA-font-light HOA-sm-pB3 HOA-guest-payment-flex-text u-mR2">{{registeredUserMessage}}</div>
            <button tid="login"
                    class="HOA-splash-buttons-container__button Button Button--blue"
                    type="button"
                    (click)="login()">
                Login
            </button>
        </div>
    </div>
    <div *ngIf="personalInfoData.registration && !personalInfoData.accountActive"
         class="u-mB7 u-mH4 u-bgBlueLightest u-rounded u-pA4 HOA-flextable-component__cell&--100-field">
        <div tid="inactiveUserLabel" id="inactiveUserLabel" class="HOA-guest-payment-header-light u-pB3">
            Inactive User
        </div>
        <div class="HOA-flex-component HOA-guest-payment-sm-col-lg-row HOA-guest-payment-register-flex">
            <div class="HOA-font-light HOA-sm-pB3 HOA-guest-payment-flex-text u-mR2">
                Thank you for registering. Your account is not yet active.  Please try again in 24 hours to
                complete the activation process. If you need to make a payment immediately, please select Pay
                Assessments. We apologize for the delay.
            </div>
        </div>
    </div>
    <div class="Field HOA-flextable-component__cell--100-field HOA-flextable-component__cell-field"
         [ngClass]="{ 'is-invalid': phoneNumberError }"
         aria-invalid="phoneNumberError"
         attr.aria-describedby="{{phoneNumberError && 'phoneNumber-error' || undefined }}">
        <label tid="phoneNumberLabel" id="phoneNumberLabel" class="Field-label" for="input-text-phone-number">
            Phone Number
            <span class="asterisk-required">&nbsp;&#42;</span>
        </label>
        <div class="Field-addonBox">
            <div class="Field-addon HOA-Field-addon HOA-Field-phone-select Select">
                <!-- this text is hidden but needed for accessibility -->
                <label for="countryCode" class="hide">
                    Country Code
                </label>
                <select id="countryCode"
                        tid="countryCode"
                        [(ngModel)]="countryCode"
                        (change)="onCountryCodeChange()">
                    <option *ngFor="let code of countryCodes" [ngValue]="code">
                        {{code.country + ' (+' + code.value + ')'}}
                    </option>
                </select>
                <span class="Select-arrow"></span>
            </div>

            <input type="text"
                   class="Input HOA-Field-phone-input"
                   id="input-text-phone-number"
                   tid="phoneNumber"
                   #phoneNumberInput
                   phone-number [countryCode]="countryCode"
                   [ngClass]="{ 'is-invalid': phoneNumberError }"
                   [(ngModel)]="personalInfoData.homeowner.contactInformation.phones[0].value"
                   (blur)="checkPhoneNumberLength()"
                   required
                   autocapitalize="off"
                   autocomplete="off"
                   autocorrect="off"
                   spellcheck="false"/>
            <span class="Field-error" tid="phoneNumber-error" id="phoneNumber-error">
                        Please enter a valid phone number.
                    </span>
        </div>
    </div>
</div>`;
// Exports
module.exports = code;